export const environment = {
  production: true,
  // baseUrl: 'https://learn-app-api-nest-f5512515c073.herokuapp.com'
  baseUrl: 'https://sparkly-api-662534792143.europe-west1.run.app',
  firebaseConfig: {
    apiKey: "AIzaSyDfmokNWx4Fjf_6rA26Nb5I-xouUUA_zYU",
    authDomain: "sparkly-auth.firebaseapp.com",
    projectId: "sparkly-auth",
    storageBucket: "sparkly-auth.firebasestorage.app",
    messagingSenderId: "322900170075",
    appId: "1:322900170075:web:d4d73a976dfd9b9238767e",
    measurementId: "G-50F9YBN84P"
  }
};
